import { selectBasketCheckPrice, selectBasketRentingSummary, selectBasketTenantData } from 'containers/OrderDetails/basketSlice'
import { selectUserId } from 'containers/Login/loginSlice'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { LOCATION_STATES } from 'utils/constants'
import React, { useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { displayPrice } from 'utils/string'
import { useReduxSelector } from 'store'

interface SummaryProps {
  list: any[]
}

const Summary: React.FC<SummaryProps> = ({ list }) => {
  const checkout = useReduxSelector(selectBasketRentingSummary)
  const checkPrice = useReduxSelector(selectBasketCheckPrice)
  const tenant = useReduxSelector(selectBasketTenantData)
  const userId = useReduxSelector(selectUserId)
  const [isExpanded, expand] = useState(false)

  const summaryRef = useRef<HTMLDivElement>(null)

  const { t } = useTranslation('basket')
  const { push, goBack, replace } = useHistory()
  const onTouch: React.TouchEventHandler<HTMLDivElement> = e => {
    const summary = summaryRef.current
    if (!summary) return

    const initialY = e.touches[0].clientY
    const touchMove = (e: TouchEvent) => {
      const currentY = e.touches[0].clientY
      if ((initialY - currentY > 20 && !isExpanded) || (currentY - initialY > 20 && isExpanded)) {
        expand(!isExpanded)
        touchEnd()
      }
    }
    const touchEnd = () => {
      summary.removeEventListener('touchend', touchEnd, false)
      summary.removeEventListener('touchmove', touchMove, false)
    }
    summary.addEventListener('touchend', touchEnd, false)
    summary.addEventListener('touchmove', touchMove, false)
  }

  const redirect = (() => {
    for (const item of list) {
      const cp = checkPrice?.[item.identifier]
      const thereAreAvailableWarehouseLocks = ((cp?.commonLockInfo?.key === 'full-automatic' || cp?.warehouseLockInfo?.key === 'full-automatic')
        ? false
        : (!!cp?.lock?.openingMethods && cp.lock.openingMethods.length > 0))
      const thereAreAvailablePlaceLocks = ((cp?.commonLockInfo?.key === 'full-automatic' || cp?.placeLockInfo?.key === 'full-automatic')
        ? false
        : (!!cp?.placeLock?.gate?.openingMethods && cp.placeLock.gate.openingMethods.length > 0))
      const thereAreWarehouseLocksSelected = thereAreAvailableWarehouseLocks ? (item?.warehouseLocks && item.warehouseLocks.length > 0) : true
      const thereArePlaceLocksSelected = thereAreAvailablePlaceLocks ? (item?.placeLocks && item.placeLocks.length > 0) : true
      if (!thereAreWarehouseLocksSelected || !thereArePlaceLocksSelected) {
        return item.identifier
      }
    }
    return undefined
  })()

  return (
    <>
      {isExpanded && <div className='basketPopup__summary__bg' />}
      <div
        ref={summaryRef}
        onTouchStart={onTouch}
        className='basketPopup__summary'>
        {checkout?.to_pay?.monthly && checkout.to_pay.monthly.length > 0 && <>
          <div
            className='basketPopup__summary__header'
            onClick={() => {
              expand(e => !e)
            }}>
            <span>{t('monthlyFeeSchedule')}</span>
            <i className={`icon icon--chevron-${isExpanded ? 'down' : 'up'}`} />
          </div>

          <div className={`hidableElement --${isExpanded ? 'visible' : 'hidden'}`}>
            <div>
              <div className='basketPopup__summary__header__subTitle'>
                {checkout?.to_pay?.monthly?.[0]?.description || t('payableOnThe14th')}
              </div>
              {checkout?.to_pay?.monthly?.map(({ title, price_sum }: basic.Form, index: number) => <div
                key={index}
                className='basketPopup__summary__row'>
                <span>{title}</span>
                <span>{displayPrice(price_sum)}</span>
              </div>)}
            </div>
          </div>
        </>}

        <div className='basketPopup__summary__main group'>
          <div className='basketPopup__summary__price'>
            <div>{t('totalPayable')}:</div>
            <div>{checkout?.to_pay?.now?.grossPrice ? displayPrice(checkout.to_pay.now.grossPrice) : `${t('loading')}...`}</div>
          </div>
          <ArrowBtn
            showArrow={false}
            text={t(redirect ? 'completeEditing' : 'goFurther')}
            action={() => {
              if (redirect) {
                goBack()
                if (!window.location.pathname.includes(redirect)) {
                  setTimeout(() => {
                    replace(`/order/${redirect}`)
                  }, 300)
                }
              } else {
                if (window.location.pathname === '/order/summary') {
                  goBack()
                } else if (tenant?.user) {
                  push('/order/summary')
                } else if (userId) {
                  push('/order/billing')
                } else {
                  push(window.location.pathname, LOCATION_STATES.popup({ type: 'login' }))
                }
              }
            }}
          />
        </div>
      </div>
    </>
  )
}

export default Summary